import React from "react";

const LEAF_URL =
  "https://files.manuscdn.com/user_upload_by_module/session_file/310519663327876234/ERKkzXAtpyqdCPkM.png";

interface Props {
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Crystal cannabis leaf image — replaces the generic lucide <Leaf> icon
 * throughout the Releafa website.
 *
 * Usage:
 *   <CannabisLeafIcon className="w-5 h-5" />
 *
 * The className is applied directly to the <img> element so Tailwind
 * sizing classes (w-*, h-*) work exactly like they do on <Leaf>.
 */
export default function CannabisLeafIcon({ className = "w-5 h-5", style }: Props) {
  return (
    <img
      src={LEAF_URL}
      alt="cannabis leaf"
      className={className}
      style={{ objectFit: "contain", display: "inline-block", ...style }}
    />
  );
}
